<template>

  <div class="menu">
    <div class="menu-items">
      <!-- <a
        href="/company/search"
        class="search-icon"
        :class="this.menuSelected.companySearch && 'search-active'"
        >{{ $t("searchName") }}</a
      > -->
      <a href="/home" v-if="!this.isUserMarketing(user)" :class="this.menuSelected.dashboard && 'menu-active'">{{
          $t("dashboardName")
      }}</a>
      <!-- only if user is admin we show user management -->
      <a href="/manage_offers"  :class="menuSelected.manageOffers && 'menu-active'">{{
        (this.isUserAdmin(user) || this.isUserMarketing(user)) ? $t("manageOffersName"): $t("myOffersName")
      }}</a>
      <!-- v-if="!this.isUserAdmin(user) && !this.isUserMarketing(user)"  -->
      <!-- v-if="!this.isUserAdmin(user) && !this.isUserMarketing(user)"  -->
      <!-- v-if="!this.isUserAdmin(user) && !this.isUserMarketing(user)"  -->
      <a href="/offers" v-if="!this.isUserMarketing(user)" class="offers" :class="menuSelected.offers && 'menu-active'">{{ $t("offersName")
      }}</a>
      <a href="/events" v-if="!this.isUserMarketing(user)" class="events" :class="menuSelected.events && 'menu-active'">{{ $t("eventsName") }}</a>
      <a href="/trainings" v-if="!this.isUserMarketing(user)" class="trainings" :class="menuSelected.trainings && 'menu-active'">{{ $t("trainingsName")
      }}</a>
      <a href="/profile" v-if="!this.isUserMarketing(user)" class="profile" :class="menuSelected.profile && 'menu-active'">{{ $t("profileName") }}</a>
      <a href="/friends" v-if="!this.isUserMarketing(user)" class="friends" :class="menuSelected.friends && 'menu-active'">
        {{$t("friends")}}
      </a>
      <a href="/membership" v-if="!this.isUserMarketing(user)" :class="menuSelected.membership && 'menu-active'">{{ $t("membershipName") }}</a>
      <!-- only if user is admin we show user management -->
      <a href="/manage_users" v-if="this.isUserAdmin(user) " :class="menuSelected.manageUsers && 'menu-active'">{{
          $t( "manageUsersName")
      }}</a>
      <a href="/manage_admins" v-if="this.isUserMarketing(user) " :class="menuSelected.manageAdmins && 'menu-active'">{{
          $t( "manageAdminsName")
      }}</a>      <!--
      <a
        href="/contact"
        class="contact"
        :class="this.menuSelected.contact && 'contact-active'"
        >{{ $t("contactName") }}</a
      >
      <a
        href="/faq"
        class="faq"
        :class="this.menuSelected.faq && 'faq-active'"
        >{{ $t("faqName") }}</a
      > -->
      <a href="/terms" v-if="!this.isUserMarketing(user)" class="term" :class="menuSelected.terms && 'menu-active'">{{ $t("termsAndConditionsName")
      }}</a>

      <a href="#" class="logout" @click="logout()">{{ $t("logoutName") }}</a>
    </div>
    <div class="socials">
      <a href="https://www.facebook.com/UpRomania" target="_blank" class="facebook"></a>
      <a href="https://www.linkedin.com/company/up-romania" target="_blank" class="linkedin"></a>
      <a href="https://www.youtube.com/c/UpRomaniaBucuresti" target="_blank" class="youtube"></a>
    </div>
  </div>

</template>
<script>
import Cookies from "js-cookie";
export default {
  name: "MenuItems",
  props: {
    user: Object,
    menuSelected: Object, 
    // {
    //   dashboard: false,
    //   offers: false,
    //   events: false,
    //   trainings: false,
    //   friends: false,
    //   membership: false,
    //   profile: false,
    //   contact: false,
    //   terms: false,
    //   gdpr: false,
    //   companySearch: false,
    //   manageUsers: false,
    //   manageOffers: false,
    // },
  },
  methods: {
    logout() {
      Cookies.remove("user_role");
      Cookies.remove("token");
      this.$router.push({
        name: "login",
      });
    },
    goBack() {
      window.history.length > 1 ? this.$router.go(-1) : this.$router.push("/");
    },
  },
};
</script>
<style scoped src="@/assets/styles/beneficiary.css">

</style>
